/**
 * Configuration for @ngrx/data extension.
 * @see https://ngrx.io/guide/data
 * @author Michal Drewniak (michal@blaze.tech)
 */

import {
  type DefaultDataServiceConfig,
  type EntityDataModuleConfig,
  type EntityMetadataMap,
} from '@ngrx/data';

import { type AccountInfo } from '@blaze-shared/api-contracts-domain';

import { environment } from '../../environments/environment';

const entityMetadata: EntityMetadataMap = {
  account: {
    selectId: (accountInfo: AccountInfo) => accountInfo.id || '',
  },
  connector: {},
  'connectors/template': {},
  dataset: {},
  project: {},
  projectGroup: {},
  table: {},
  user: {},
  variable: {},
};

export const entityConfig: EntityDataModuleConfig = {
  entityMetadata,
};

export const dataServiceConfig: DefaultDataServiceConfig = {
  root: environment.apiUrl,
};
